import React, { useState, createContext } from "react"

export const ForumContext = createContext({
    message: "",
    setMessage: () => {},
    shouldUpdateForumTopic: false,
    setShouldUpdateForumTopic: () => {}
})

export default function ForumProvider(props) {
    const { children } = props
    const [message, setMessage] = useState("")
    const [shouldUpdateForumTopic, setShouldUpdateForumTopic] = useState(false)

    return (
        <ForumContext.Provider
            value={{
                message,
                setMessage,
                shouldUpdateForumTopic,
                setShouldUpdateForumTopic
            }}
        >
            {children}
        </ForumContext.Provider>
    )
}
